import React, { Component, PropTypes } from 'react'

import { getProperty } from '../utils'

import { Loading } from '../misc'
import Header from '../header'
import JobsList from '../../containers/jobs_list'
import { Button, Label, Select, TextInput } from '../ui'

class JobHistory extends Component {
    static propTypes = {
        account: PropTypes.object.isRequired,
        jobs: PropTypes.object.isRequired,
        jobsActions: PropTypes.objectOf(PropTypes.func).isRequired,
    }

    state = {
        year: (new Date()).getFullYear(),
        month: null,
        pay_date: null,
        job_number: null,
    }

    componentWillMount() {
        if (! this.props.jobs.history) {
            this.props.jobsActions.loadJobs(this.props.account.user.crew.uuid, true)
        }
    }

    _getYearFilterOptions() {
        const years = this.props.jobs.history.map((item) => item.job_date.year())

        const min = Math.min(...years)
        const max = Math.max(...years)

        const out = []

        for (let i = min; i <= max; i++) {
            out.push({
                value: i,
                label: `${ i }`,
            })
        }

        return out
    }

    _getMonthFilterOptions() {
        return [
            'January', 'February', 'March', 'April', 'May', 'June', 'July',
            'August', 'September', 'October', 'November', 'December',
        ].map((label, value) => {
            return {
                value,
                label,
            }
        })
    }

    _updateField = (local, passed) => (data) => this.setState({ [local]: data[passed] })

    _clearFilters = () => {
        this.setState({
            year: null,
            month: null,
            pay_date: null,
            job_number: null,
        })
    }

    _filterJobs() {
        let filteredJobs = this.props.jobs.history

        if (getProperty(this.state, 'year') !== null) {
            filteredJobs = filteredJobs.filter((item) => item.job_date.year() === this.state.year)
        }
        if (getProperty(this.state, 'month') !== null) {
            filteredJobs = filteredJobs.filter((item) => item.job_date.month() === this.state.month)
        }
        if (getProperty(this.state, 'pay_date') !== null) {
            filteredJobs = filteredJobs.filter(
                (item) => item.pay_date.format('YYYY-MM-DD') === this.state.pay_date
            )
        }
        if (getProperty(this.state, 'job_number') !== null) {
            filteredJobs = filteredJobs.filter((item) => item.job_number.includes(this.state.job_number))
        }

        return filteredJobs
    }

    render() {
        if (! this.props.jobs.history) {
            return (
                <div>
                    <Header title="Job History" />

                    <div className="content">
                        <div className="content__inner">
                            <Loading />
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <Header title="Job History" />

                <div className="content">
                    <div className="content__inner content__inner--fluid">
                        { this.props.account.user.crew.onboarding_complete || (
                            <div className="alert alert--error text-strong">
                                Please fully complete your profile to be considered for the maximum
                                number of job opportunities.
                            </div>
                        ) }

                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">Job History &mdash; all of your Man With A Cam jobs</div>
                            </div>
                            <div className="box__content box__content--padded">
                                <Filters
                                    clearFilters={ this._clearFilters }
                                    monthFilterOptions={ this._getMonthFilterOptions() }
                                    updateField={ this._updateField }
                                    values={ this.state || {} }
                                    yearFilterOptions={ this._getYearFilterOptions() }
                                />

                                <JobsList jobs={ this._filterJobs() } />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class Filters extends Component {
    static propTypes = {
        clearFilters: React.PropTypes.func.isRequired,
        monthFilterOptions: React.PropTypes.array.isRequired,
        updateField: React.PropTypes.func.isRequired,
        values: React.PropTypes.object.isRequired,
        yearFilterOptions: React.PropTypes.array.isRequired,
    }

    render() {
        return (
            <div>
                <div className="grid grid--break-mobile">
                    <div className="grid grid__span-3">
                        <Label htmlFor="id_filter_year">Year</Label>
                        <Select
                            name="filter_year"
                            options={ this.props.yearFilterOptions }
                            updateValue={
                                this.props.updateField('year', 'filter_year')
                            }
                            value={ getProperty(this.props.values, 'year') }
                        />
                    </div>
                    <div className="grid grid__span-3">
                        <Label htmlFor="id_filter_month">Month</Label>
                        <Select
                            name="filter_month"
                            options={ this.props.monthFilterOptions }
                            updateValue={
                                this.props.updateField('month', 'filter_month')
                            }
                            value={ getProperty(this.props.values, 'month') }
                        />
                    </div>
                    <div className="grid grid__span-3">
                        <Label htmlFor="id_filter_pay_date">Pay date</Label>
                        <TextInput
                            help="Enter in YYYY-MM-DD format"
                            name="filter_pay_date"
                            updateValue={
                                this.props.updateField('pay_date', 'filter_pay_date')
                            }
                            value={ getProperty(this.props.values, 'pay_date') }
                        />
                    </div>
                    <div className="grid grid__span-3">
                        <Label htmlFor="id_filter_job_number">Job number</Label>
                        <TextInput
                            name="filter_job_number"
                            updateValue={
                                this.props.updateField('job_number', 'filter_job_number')
                            }
                            value={ getProperty(this.props.values, 'job_number') }
                        />
                    </div>
                </div>
                <Button onClick={ this.props.clearFilters }>Clear filters</Button>
            </div>
        )
    }
}

export default JobHistory



// WEBPACK FOOTER //
// ./app/components/jobs/job_history.js